<a class="navbar-brand-test" [routerLink]="['/dashboard']" href="javascript:void(0)">
    <div id="myHRcounsel">
        <img src="assets/images/myHRcounsel-logo.png" alt="">
    </div>
</a>


<!-- <nav class="active navbar-collapse" id="navbarSupportedContent"> -->

    <div id="sidebar2" class="d-sm-block d-md-none">
        <div class="header-sidebar">
            <div class="btn-group-vertical">
                <a href="javascript:void(0)" [routerLink]="['/dashboard']" 
                   routerLinkActive="active" class="btn">
                    Home
                </a>
                <a href="javascript:void(0)" [routerLink]="['/ticket']" routerLinkActive="active"
                   class="btn">
                    Ask an Attorney
                </a>
                <a href="javascript:void(0)" [routerLink]="['/hr-menu/solution-center']" routerLinkActive="active"
                    class="btn" aria-hidden="true">
                    Solutions Center
                </a>
                <a href="javascript:void(0)" [routerLink]="['/hr-menu/business-center']" routerLinkActive="active"
                    class="btn" aria-hidden="true">
                    Business Center
                </a>
            </div>      

        </div>
    </div>


<!-- </nav>
 -->
